import {useAuth0} from "@auth0/auth0-react";
import React, {useEffect, useState} from "react";
import {CodeSnippet} from "../../components/code-snippet";
import {PageLayout} from "../../components/page-layout";
import {useForm} from "react-hook-form";
import { getCompanies, saveListRepresentation } from "../../services/admin.service";
import { toast } from 'react-toastify';
import Dropdown from 'react-bootstrap/Dropdown';
import { DropdownButton } from "react-bootstrap";


export const PageRepresentation = () => {
  const {getAccessTokenSilently} = useAuth0();

  const [userId, setUserId] = useState("");
  const [error, setError] = useState("");

  const {register, handleSubmit, setValue, formState: {errors}} = useForm();
  const [options, setOptions] = useState([]);
  const onSubmit = data => getRepresentationData(data)

  const getRepresentationData = async (elections) => {
    const electionArray = elections.elections.split(', ');
    const accessToken = await getAccessTokenSilently();
    const postData = {"siret": elections.siret, "polls": electionArray}
    const {data, error} = await saveListRepresentation(accessToken, postData);

    if (data) {
      setError("")
      setUserId(data.id);
      toast.success('Fichiers enregistrees');
    }

    if (error) {
      setUserId("")
      setError(JSON.stringify(error, null, 2));
    }
  };

  //copy
  const [isCopied, setIsCopied] = useState(false);

  async function copyTextToClipboard(text) {
    if ('clipboard' in navigator) {
      return await navigator.clipboard.writeText(text);
    } else {
      return document.execCommand('copy', true, text);
    }
  }

  useEffect(() => {
    async function fetchCompanies() {
      const accessToken = await getAccessTokenSilently();
      const { data, error } = await getCompanies(accessToken);
      const results = [];
      // Store results in the results array
      data.forEach((value) => {
        results.push({
          key: value.second,
          value: value.first + ' - ' + value.second
        });
      });

      setOptions([
        {key: 'Select a company', value: ''},
        ...results
      ])
    }
    fetchCompanies();
  }, []);

  function onCompanySelect(event) {
    setValue("siret", event)
  }

  const handleCopyClick = () => {
    // Asynchronously call copyTextToClipboard
    copyTextToClipboard(userId)
      .then(() => {
        // If successful, update the isCopied state value
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 1500);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  return (
    <PageLayout>
      <div className="content-layout">
        <h1 id="page-title" className="content__title">
          Create representation PDF
        </h1>
        <div className="content__body">
          <p id="page-description">
                    <span>
                      This page creates the <strong>representation pdfs</strong> from a list of IDs.
                    </span>
          </p>
          <div>
            {
                <DropdownButton
                  id={`dropdown-variants}`}
                  title='Select existing company'
                  onSelect={onCompanySelect}
                >
                  {options.map(
                      (variant) => (
                        <Dropdown.Item eventKey={variant.key}>{variant.value}</Dropdown.Item>
                      ))}
                </DropdownButton>
              }
            <br/>
            <br/>
            <form onSubmit={handleSubmit(onSubmit)}>
              <p>Enter Siret code:</p>
              <p>
                <input {...register("siret", {required: true})}/>
              </p>
              <p>Poll IDs, separated by , :</p>
              <p>
                <textarea className="large-textarea" {...register("elections", {required: true})} />
              </p>
              {errors.email && <p>This field is required</p>}
              <input type="submit" className="button button--compact button--primary"/>
            </form>
            {userId && <div>
              <span>{userId}</span>
              <button onClick={handleCopyClick}>
                <span>{isCopied ? 'Copied!' : 'Copy'}</span>
              </button>
            </div>}
            {error && <CodeSnippet title="Protected Message" code={error}/>}
          </div>
        </div>
      </div>
    </PageLayout>
  );
};
